(function () {
  function init(root) {
    if (root.__ls) return;
    root.__ls = true;
    var btn = root.querySelector('[data-lang-toggle]');
    var menu = root.querySelector('[data-lang-menu]');
    if (!btn || !menu) return;
    function open(state) {
      menu.hidden = !state;
      btn.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) { e.stopPropagation(); open(menu.hidden); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { open(false); btn.focus(); } });
    var sel = root.querySelector('[data-lang-country]');
    if (sel) sel.addEventListener('change', function () { sel.form.submit(); });
  }
  function boot() { document.querySelectorAll('[data-lang-switch]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
